export default __webpack_public_path__ + "static/media/concierge-entry-desktop.3651d7a7.png";